import { useQuery } from "@tanstack/react-query";
import { positionGet } from "common/api/sakusas/sakusas_position";
import { QUERY_KEYS } from "constant/react_query";

export const useSakusasPositionGet = (id: string) => {
  const { data: position } = useQuery(
    [QUERY_KEYS.SAKUSAS_VIDEO_GET, id],
    async () => {
      const result = await positionGet(id);
      return result;
    },
    { staleTime: Infinity }
  );
  const result =
    typeof position !== "undefined" && position !== "" ? position : null;
  return result;
};
